module.exports = __webpack_public_path__ + "assets/6ca0cf2a7f734bc5e97efb7998794ed1.svg";